var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScientist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1747,
    height: 922,
    viewBox: "0 0 1747 922",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 921,
    fill: "#005D5F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56_6275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1747,
    height: 921
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 921,
    fill: "#005D5F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56_6275)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450.5,
    cy: 208.5,
    r: 610.5,
    fill: "black",
    fillOpacity: 0.29
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1066.36 305.854H1034.24V341.845H1066.36V305.854Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.74 291.921H1017.6V313.98H1078.74V291.921Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.44 330.622H980.057V697.506H1117.44V330.622Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.46 475.363C1053.13 475.363 1069.07 459.422 1069.07 439.758C1069.07 420.094 1053.13 404.153 1033.46 404.153C1013.8 404.153 997.859 420.094 997.859 439.758C997.859 459.422 1013.8 475.363 1033.46 475.363Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.17 790.775L1259.09 711.825H1077.2L1014.5 790.775H1322.17Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.62 712.6H1071.39C1059.39 712.6 1049.33 702.925 1049.33 690.54V688.992H1342.3V690.54C1342.68 702.925 1332.62 712.6 1320.62 712.6Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.35 206.045L1169.23 241.967L1176.42 252.991L1231.54 217.069L1224.35 206.045Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.68 167.891L1204.12 201.488L1225.68 234.56L1277.23 200.963L1255.68 167.891Z",
    fill: "#D7D7D7",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.75 118.154H1042.36V158.403H1054.75V118.154Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.55 155.693H1035.4V235.03H1060.55V155.693Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.2 226.516H1018.76V272.183H1077.2V226.516Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.63 204.457L1105.06 260.96L957.61 273.732L961.093 311.658L1138.73 296.178L1199.1 251.285L1171.63 204.457Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M841.894 822.964H839.43C830.394 822.964 823.001 815.571 823.001 806.535V639.779H858.734V806.535C858.323 815.571 850.93 822.964 841.894 822.964Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M822.591 707.137V804.89C822.591 814.748 830.394 822.552 840.252 822.552C850.109 822.552 857.913 814.748 857.913 804.89V706.727H822.591V707.137Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M864.485 634.029H816.43V667.709H864.485V634.029Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M909.665 822.964C899.808 822.964 892.004 815.16 892.004 805.303V639.779H927.737V804.892C927.737 814.749 919.523 822.964 909.665 822.964Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M892.004 707.137V804.89C892.004 814.748 899.808 822.552 909.665 822.552C919.523 822.552 927.327 814.748 927.327 804.89V706.727H892.004V707.137Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M933.898 634.029H885.843V667.709H933.898V634.029Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M979.078 822.964C969.221 822.964 961.417 815.16 961.417 805.303V639.779H997.15V804.892C997.15 814.749 988.935 822.964 979.078 822.964Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M961.417 707.137V804.89C961.417 814.748 969.22 822.552 979.078 822.552C988.935 822.552 996.739 814.748 996.739 804.89V706.727H961.417V707.137Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.9 634.029H954.845V667.709H1002.9V634.029Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.49 822.964C1038.63 822.964 1030.83 815.16 1030.83 805.303V639.779H1066.56V804.892C1066.56 814.749 1058.35 822.964 1048.49 822.964Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.83 707.137V804.89C1030.83 814.748 1038.63 822.552 1048.49 822.552C1058.35 822.552 1066.15 814.748 1066.15 804.89V706.727H1030.83V707.137Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.31 634.029H1024.26V667.709H1072.31V634.029Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.71 685.781H792.197V696.46H1102.71V806.535H777V832H1124.07V825.839V806.535V696.46V685.781H1102.71Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.4 153.878C1216.4 153.878 1215.15 190.035 1222.95 204.373C1230.74 218.711 1243.83 224.01 1244.76 236.166C1246.01 248.322 1240.4 264.53 1248.19 268.894C1255.99 273.258 1310.53 328.116 1327.99 326.869C1345.44 325.623 1364.14 300.687 1364.14 300.687L1403.42 325.934L1456.09 217.464L1421.18 185.671C1421.18 185.671 1406.85 100.266 1387.21 76.2655C1367.57 52.2648 1294.01 45.7192 1256.92 63.1742C1219.83 80.6292 1206.43 120.215 1197.7 127.695C1188.97 135.488 1170.27 142.969 1180.24 157.307C1189.91 171.333 1216.4 153.878 1216.4 153.878Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.21 207.489C1415.26 204.372 1419.63 195.956 1423.05 187.229L1421.18 185.358C1421.18 185.358 1406.85 99.9536 1387.21 75.9529C1367.57 51.9523 1294.01 45.4067 1256.92 62.8617C1219.83 80.3167 1206.43 119.902 1197.7 127.383C1188.97 135.175 1170.27 142.656 1180.24 156.994C1189.28 170.397 1212.97 156.059 1216.09 153.877L1216.4 153.565C1216.4 153.565 1233.85 147.955 1246.01 141.409C1258.17 134.864 1271.26 123.954 1271.26 123.954C1271.26 123.954 1248.19 162.293 1256.92 174.449C1265.65 186.605 1291.83 180.995 1291.83 180.995C1291.83 180.995 1309.29 204.06 1320.19 198.45C1331.1 192.839 1315.83 172.267 1332.35 164.475C1348.87 156.682 1361.96 189.722 1361.96 195.021C1361.96 200.943 1401.24 215.281 1411.21 207.489Z",
    fill: "black",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1423.05 187.541L1346.38 276.375C1346.38 276.375 1327.68 274.193 1314.58 264.219C1301.49 254.244 1290.58 230.244 1290.58 230.244C1290.58 230.244 1346.38 168.84 1375.05 151.385C1399.99 136.111 1408.09 133.306 1409.65 132.995C1408.72 129.254 1407.78 125.514 1406.53 121.773C1400.61 124.267 1383.16 133.306 1355.1 155.748C1324.56 180.684 1260.04 245.205 1243.83 261.413C1244.14 264.53 1245.39 267.024 1247.88 268.582C1255.67 272.946 1310.22 327.805 1327.68 326.558C1331.1 326.246 1334.53 325.311 1337.96 323.441C1341.39 309.726 1347 289.154 1351.68 280.427C1357.29 270.141 1413.7 209.048 1428.98 192.529L1423.05 187.541Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.81 202.191C1325.81 202.191 1315.83 167.281 1329.23 160.424C1342.33 153.878 1358.85 168.216 1361.03 183.489C1363.21 198.762 1355.42 217.464 1355.42 217.464C1355.42 217.464 1363.21 232.737 1359.78 249.257",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.81 202.191C1325.81 202.191 1315.83 167.281 1329.23 160.424C1342.33 153.878 1358.85 168.216 1361.03 183.489C1363.21 198.762 1355.42 217.464 1355.42 217.464C1355.42 217.464 1363.21 232.737 1359.78 249.257",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1269.39 229.308C1271.57 233.672 1271.57 237.724 1269.39 238.971C1267.21 240.218 1263.78 237.724 1261.6 233.361C1259.41 228.997 1259.41 224.945 1261.6 223.698C1263.78 222.451 1267.21 224.945 1269.39 229.308Z",
    fill: "#005D5F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.02 209.047C1241.02 209.047 1242.27 193.774 1260.66 196.891",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.91 204.684L1371.31 336.531L1403.73 360.22L1479.78 216.84L1453.91 204.684Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1474.17 219.334C1474.17 219.334 1410.27 329.986 1398.12 354.61C1385.96 379.234 1350.12 439.703 1347.62 475.549C1345.44 511.394 1319 918.5 1319 918.5L1595.5 921C1595.5 921 1610.7 561.888 1609.45 500.173C1608.2 438.768 1592.62 348.065 1545.55 286.349C1498.8 224.945 1474.17 219.334 1474.17 219.334Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.61 235.854C1496.61 235.854 1458.59 307.544 1432.72 348.688C1406.85 390.143 1373.49 434.716 1364.46 460.587C1355.42 486.458 1355.42 497.367 1355.42 497.367",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.53 517.937L1136.29 495.495C1136.29 495.495 1121.64 458.715 1112.92 448.429C1103.88 438.455 1091.72 440.637 1083.93 431.598C1076.14 422.558 1067.1 402.61 1062.73 400.428C1058.37 398.246 1048.08 403.857 1048.08 412.584C1048.08 421.623 1058.06 435.961 1058.06 439.39C1058.06 442.819 1058.06 442.819 1058.06 442.819C1058.06 442.819 1020.03 431.598 1015.67 435.026C1011.3 438.455 1006.63 449.676 1010.06 455.287C1013.48 460.897 1020.03 463.079 1020.03 467.443C1020.03 471.806 1012.24 486.456 1016.6 492.067C1020.97 497.677 1027.82 501.106 1027.82 501.106C1027.82 501.106 1027.82 522.301 1034.68 531.34C1041.54 540.38 1092.97 546.925 1108.55 549.107C1124.14 551.289 1169.96 573.731 1169.96 573.731L1166.53 517.937Z",
    fill: "#DCEEFF",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.95 325.622C1462.95 325.622 1414.95 348.999 1396.87 410.715C1379.11 472.119 1367.88 536.017 1367.88 536.017C1367.88 536.017 1356.66 533.835 1356.66 540.381C1356.66 547.238 1355.42 550.355 1355.42 550.355L1160.92 513.575L1156.55 605.214C1156.55 605.214 1409.34 652.28 1422.74 652.28C1436.15 652.28 1450.8 647.916 1455.16 636.695C1459.52 625.474 1532.46 462.145 1532.46 462.145",
    fill: "#DFE33D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.95 325.622C1462.95 325.622 1414.95 348.999 1396.87 410.715C1379.11 472.119 1367.88 536.017 1367.88 536.017C1367.88 536.017 1356.66 533.835 1356.66 540.381C1356.66 547.238 1355.42 550.355 1355.42 550.355L1160.92 513.575L1156.55 605.214C1156.55 605.214 1409.34 652.28 1422.74 652.28C1436.15 652.28 1450.8 647.916 1455.16 636.695C1459.52 625.474 1532.46 462.145 1532.46 462.145",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.39 377.052C1485.39 377.052 1523.42 398.247 1530.28 427.547",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.59 409.468C1462.02 409.468 1519.06 413.831 1531.21 446.248",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.95 508.9C1510.95 508.9 1554.59 488.639 1567.99 445.002",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.7 551.602C1365.7 551.602 1388.15 593.057 1386.9 622.045",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.11 544.744C1379.11 544.744 1401.55 549.108 1417.13 579.342",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138.407 703.979C136.081 710.959 135.305 717.939 135.305 725.694C135.305 767.571 169.428 801.694 211.305 801.694C253.183 801.694 287.305 767.571 287.305 725.694C287.305 717.939 286.53 710.959 284.203 703.979H138.407Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M240.776 645.816V545H181.837V645.816C149.265 658.225 126 689.245 126 725.694C126 773 164 811 211.306 811C258.612 811 296.612 773 296.612 725.694C296.612 688.469 273.347 657.449 240.776 645.816Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M483.512 703.979C481.186 710.959 480.41 717.939 480.41 725.694C480.41 767.571 514.533 801.694 556.41 801.694C598.288 801.694 632.41 767.571 632.41 725.694C632.41 717.939 631.635 710.959 629.308 703.979H483.512Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M586.654 645.816V545H527.715V645.816C495.144 658.225 471.879 689.245 471.879 725.694C471.879 773 509.879 811 557.185 811C604.491 811 642.491 773 642.491 725.694C642.491 688.469 619.226 657.449 586.654 645.816Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M322.205 731.897C320.654 737.326 319.879 741.979 319.879 748.183C319.879 779.203 345.471 804.795 376.491 804.795C407.511 804.795 433.103 779.203 433.103 748.183C433.103 742.754 432.328 737.326 430.777 731.897H322.205Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M398.981 688.469V613.244H354.777V688.469C330.736 697.775 313.675 720.265 313.675 747.408C313.675 782.306 342.368 810.999 377.266 810.999C412.164 810.999 440.858 782.306 440.858 747.408C440.083 720.265 423.022 696.999 398.981 688.469Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.514 263.78H474.592L491.889 91H363.81L346.514 263.78Z",
    fill: "#E8E8E8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.514 263.78H474.592L491.889 91H363.81L346.514 263.78Z",
    stroke: "#E8E8E8",
    strokeWidth: 5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.601 263.78H470.062L487.36 91H356.897L339.601 263.78Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.601 263.78H470.062L487.36 91H356.897L339.601 263.78Z",
    stroke: "#E8E8E8",
    strokeWidth: 5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.589 240.968H449.643L462.371 113.814H377.317L364.589 240.968Z",
    fill: "#E8E8E8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.74 217.353C152.74 226.516 160.17 233.945 169.334 233.945H318.627V200.759H169.334C160.17 200.759 152.74 208.188 152.74 217.353Z",
    fill: "#005D5F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.153 217.353C253.153 222.657 257.453 226.958 262.758 226.958H318.226C318.447 226.958 318.627 226.78 318.627 226.56V208.144C318.627 207.924 318.447 207.746 318.226 207.746H262.758C257.453 207.746 253.153 212.047 253.153 217.353Z",
    fill: "#E8E8E8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.903 233.945V267.132H294.856C304.02 267.132 311.45 259.702 311.45 250.539C311.45 241.375 304.02 233.945 294.856 233.945H131.903Z",
    fill: "#005D5F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.903 241.027V260.055H198.903C204.157 260.055 208.417 255.795 208.417 250.541C208.417 245.286 204.157 241.027 198.903 241.027H131.903Z",
    fill: "#E8E8E8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 289.178H640.733V265.581H79V289.178Z",
    fill: "#E8E8E8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.733 289.178H733.143V265.581H640.733V289.178Z",
    fill: "#005D5F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.91 289.18L259.777 358.001V289.18H215.91Z",
    fill: "#E9E9E9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.635 289.18L235.502 358.001H259.777L215.91 289.18H191.635Z",
    fill: "#005D5F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.645 289.18L581.512 358.001V289.18H537.645Z",
    fill: "#E9E9E9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.369 289.18L557.236 358.001H581.512L537.645 289.18H513.369Z",
    fill: "#005D5F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M564.768 254.529L545.937 181.485V161.513H519.307V181.485L500.475 254.529C499.144 259.475 502.948 264.23 507.894 264.23H557.16C562.486 264.23 566.1 259.475 564.768 254.529Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M549.551 217.627H516.073L506.182 256.051C505.991 256.812 506.372 257.573 506.562 257.763C506.752 258.143 507.323 258.524 508.084 258.524H557.35C558.301 258.524 558.682 257.953 558.872 257.763C559.062 257.573 559.442 256.812 559.252 256.051L549.551 217.627Z",
    fill: "#00415F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M618.98 195.18V152.952H594.252V195.18C580.746 200.126 570.855 213.251 570.855 228.659C570.855 248.441 586.833 264.419 606.616 264.419C626.399 264.419 642.377 248.441 642.377 228.659C642.377 213.251 632.676 200.126 618.98 195.18Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M576.182 219.528C575.421 222.382 574.85 225.425 574.85 228.659C574.85 246.349 589.116 260.615 606.807 260.615C624.497 260.615 638.763 246.349 638.763 228.659C638.763 225.425 638.383 222.572 637.432 219.528H576.182Z",
    fill: "#00415F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M692.405 218.576V141.348H676.046V218.576C667.106 221.81 660.638 230.56 660.638 240.641C660.638 253.576 671.1 264.228 684.225 264.228C697.16 264.228 707.812 253.766 707.812 240.641C707.812 230.56 701.345 222 692.405 218.576Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M664.062 234.744C663.492 236.646 663.111 238.548 663.111 240.641C663.111 252.244 672.432 261.755 684.225 261.755C695.828 261.755 705.339 252.434 705.339 240.641C705.339 238.548 704.959 236.646 704.388 234.744H664.062Z",
    fill: "#00415F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 806,
    width: 630.987,
    height: 25.7237,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 123.684,
    y: 824.157,
    width: 18.1579,
    height: 96.8421,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 580.658,
    y: 824.157,
    width: 18.1579,
    height: 96.8421,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientist);
export default __webpack_public_path__ + "static/media/scientist.23040b78a72623b7cdde5ba7ded5f127.svg";
export { ForwardRef as ReactComponent };